// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"f21ad842","787":"bf78d262"}[chunkId] + ".chunk.js";
};